/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CodeCommentsUpdate,
  CodeCreate,
  CodeRead,
  CodeType,
  CodeUpdate,
  HTTPValidationError,
  PaginatedCodesResponse,
} from '../models/index';
import {
    CodeCommentsUpdateFromJSON,
    CodeCommentsUpdateToJSON,
    CodeCreateFromJSON,
    CodeCreateToJSON,
    CodeReadFromJSON,
    CodeReadToJSON,
    CodeTypeFromJSON,
    CodeTypeToJSON,
    CodeUpdateFromJSON,
    CodeUpdateToJSON,
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
    PaginatedCodesResponseFromJSON,
    PaginatedCodesResponseToJSON,
} from '../models/index';

export interface CreateCodeRequest {
    codeCreate: CodeCreate;
}

export interface DeleteCodeRequest {
    codeId: string;
}

export interface GetCodeRequest {
    codeId: string;
}

export interface GetOrganizationCodesRequest {
    xOrganizationID?: string | null;
}

export interface GetUserCodesRequest {
    userId: string;
    xOrganizationID?: string | null;
}

export interface ListCurrentUserCodesPageRequest {
    skip?: number;
    limit?: number;
    search?: string | null;
    problemId?: Array<string> | null;
    type?: Array<CodeType> | null;
    order?: ListCurrentUserCodesPageOrderEnum;
}

export interface UpdateCodeRequest {
    codeId: string;
    codeUpdate: CodeUpdate;
}

export interface UpdateCodeCommentsRequest {
    codeId: string;
    codeCommentsUpdate: CodeCommentsUpdate;
    xOrganizationID?: string | null;
}

/**
 * 
 */
export class CodesApi extends runtime.BaseAPI {

    /**
     * Create a new code submission.  Users can create codes for themselves. Organization admins can create codes for any user in their organization.
     * Create Code
     */
    async createCodeRaw(requestParameters: CreateCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CodeRead>> {
        if (requestParameters['codeCreate'] == null) {
            throw new runtime.RequiredError(
                'codeCreate',
                'Required parameter "codeCreate" was null or undefined when calling createCode().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/codes/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CodeCreateToJSON(requestParameters['codeCreate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CodeReadFromJSON(jsonValue));
    }

    /**
     * Create a new code submission.  Users can create codes for themselves. Organization admins can create codes for any user in their organization.
     * Create Code
     */
    async createCode(requestParameters: CreateCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CodeRead> {
        const response = await this.createCodeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a code by ID.  Users can delete their own codes. Organization administrators can delete codes from users in their shared organizations. Anyone else gets 404, the same as for a missing code.
     * Delete Code
     */
    async deleteCodeRaw(requestParameters: DeleteCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['codeId'] == null) {
            throw new runtime.RequiredError(
                'codeId',
                'Required parameter "codeId" was null or undefined when calling deleteCode().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/codes/{code_id}`.replace(`{${"code_id"}}`, encodeURIComponent(String(requestParameters['codeId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a code by ID.  Users can delete their own codes. Organization administrators can delete codes from users in their shared organizations. Anyone else gets 404, the same as for a missing code.
     * Delete Code
     */
    async deleteCode(requestParameters: DeleteCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteCodeRaw(requestParameters, initOverrides);
    }

    /**
     * Get a specific code by ID and update last_used timestamp.  Code owners can view their code. Organization admins can view codes from users in their shared organizations. Anyone else gets 404, the same as for a missing code.
     * Get Code
     */
    async getCodeRaw(requestParameters: GetCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CodeRead>> {
        if (requestParameters['codeId'] == null) {
            throw new runtime.RequiredError(
                'codeId',
                'Required parameter "codeId" was null or undefined when calling getCode().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/codes/{code_id}`.replace(`{${"code_id"}}`, encodeURIComponent(String(requestParameters['codeId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CodeReadFromJSON(jsonValue));
    }

    /**
     * Get a specific code by ID and update last_used timestamp.  Code owners can view their code. Organization admins can view codes from users in their shared organizations. Anyone else gets 404, the same as for a missing code.
     * Get Code
     */
    async getCode(requestParameters: GetCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CodeRead> {
        const response = await this.getCodeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all codes for the current authenticated user.  Returns all codes created by the authenticated user, regardless of organization.
     * Get Current User Codes
     */
    async getCurrentUserCodesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CodeRead>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/codes/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CodeReadFromJSON));
    }

    /**
     * Get all codes for the current authenticated user.  Returns all codes created by the authenticated user, regardless of organization.
     * Get Current User Codes
     */
    async getCurrentUserCodes(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CodeRead>> {
        const response = await this.getCurrentUserCodesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get the codes of the active members of the current organization.  A member counts while they hold an active role in the organization and their account is active; removed members and deactivated accounts are left out, and each code is listed once. Organization context is determined by X-Organization-ID header or user\'s first active org. User must be an administrator in the organization to access this endpoint.
     * Get Organization Codes
     */
    async getOrganizationCodesRaw(requestParameters: GetOrganizationCodesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CodeRead>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xOrganizationID'] != null) {
            headerParameters['X-Organization-ID'] = String(requestParameters['xOrganizationID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/codes/organization`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CodeReadFromJSON));
    }

    /**
     * Get the codes of the active members of the current organization.  A member counts while they hold an active role in the organization and their account is active; removed members and deactivated accounts are left out, and each code is listed once. Organization context is determined by X-Organization-ID header or user\'s first active org. User must be an administrator in the organization to access this endpoint.
     * Get Organization Codes
     */
    async getOrganizationCodes(requestParameters: GetOrganizationCodesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CodeRead>> {
        const response = await this.getOrganizationCodesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all codes for a specific user.  Users can view their own codes, with or without an organization context. Administrators and staff of the organization in X-Organization-ID (required) can view the codes of its active members.
     * Get User Codes
     */
    async getUserCodesRaw(requestParameters: GetUserCodesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CodeRead>>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling getUserCodes().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xOrganizationID'] != null) {
            headerParameters['X-Organization-ID'] = String(requestParameters['xOrganizationID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/codes/user/{user_id}`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters['userId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CodeReadFromJSON));
    }

    /**
     * Get all codes for a specific user.  Users can view their own codes, with or without an organization context. Administrators and staff of the organization in X-Organization-ID (required) can view the codes of its active members.
     * Get User Codes
     */
    async getUserCodes(requestParameters: GetUserCodesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CodeRead>> {
        const response = await this.getUserCodesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get one page of the current user\'s own codes, for a list that loads more on scroll.  Rows are ordered by `last_used`, then `created_at`, then id. Each row carries the first 200 characters of the program (CODE_PREVIEW_LENGTH) and no Blockly workspace or teacher comments; `GET /codes/{code_id}` returns the whole code. Only the caller\'s codes are listed, whatever their roles.  Raises:     HTTPException: 401 if not authenticated     HTTPException: 422 for a negative skip, a limit outside 1..200, an unknown type or order,         a malformed problem id, a search over 200 characters, more than 50 problem ids or         more type values than there are types
     * List Current User Codes Page
     */
    async listCurrentUserCodesPageRaw(requestParameters: ListCurrentUserCodesPageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedCodesResponse>> {
        const queryParameters: any = {};

        if (requestParameters['skip'] != null) {
            queryParameters['skip'] = requestParameters['skip'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['problemId'] != null) {
            queryParameters['problem_id'] = requestParameters['problemId'];
        }

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        if (requestParameters['order'] != null) {
            queryParameters['order'] = requestParameters['order'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/codes/page`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedCodesResponseFromJSON(jsonValue));
    }

    /**
     * Get one page of the current user\'s own codes, for a list that loads more on scroll.  Rows are ordered by `last_used`, then `created_at`, then id. Each row carries the first 200 characters of the program (CODE_PREVIEW_LENGTH) and no Blockly workspace or teacher comments; `GET /codes/{code_id}` returns the whole code. Only the caller\'s codes are listed, whatever their roles.  Raises:     HTTPException: 401 if not authenticated     HTTPException: 422 for a negative skip, a limit outside 1..200, an unknown type or order,         a malformed problem id, a search over 200 characters, more than 50 problem ids or         more type values than there are types
     * List Current User Codes Page
     */
    async listCurrentUserCodesPage(requestParameters: ListCurrentUserCodesPageRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedCodesResponse> {
        const response = await this.listCurrentUserCodesPageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a code by ID.  Code owners can update their code. Organization admins can update codes from users in their shared organizations. Anyone else gets 404, the same as for a missing code.
     * Update Code
     */
    async updateCodeRaw(requestParameters: UpdateCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CodeRead>> {
        if (requestParameters['codeId'] == null) {
            throw new runtime.RequiredError(
                'codeId',
                'Required parameter "codeId" was null or undefined when calling updateCode().'
            );
        }

        if (requestParameters['codeUpdate'] == null) {
            throw new runtime.RequiredError(
                'codeUpdate',
                'Required parameter "codeUpdate" was null or undefined when calling updateCode().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/codes/{code_id}`.replace(`{${"code_id"}}`, encodeURIComponent(String(requestParameters['codeId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CodeUpdateToJSON(requestParameters['codeUpdate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CodeReadFromJSON(jsonValue));
    }

    /**
     * Update a code by ID.  Code owners can update their code. Organization admins can update codes from users in their shared organizations. Anyone else gets 404, the same as for a missing code.
     * Update Code
     */
    async updateCode(requestParameters: UpdateCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CodeRead> {
        const response = await this.updateCodeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Replace the teacher comments of a code (line number to text) and nothing else.  Staff of the organization in X-Organization-ID, for codes of its active members. An empty object removes every comment.  Raises:     HTTPException: 401 if not authenticated     HTTPException: 403 if not staff of the organization     HTTPException: 404 if the code is missing or its owner is not an active member     HTTPException: 422 for a key that is not a positive line number, an empty or too long         text (over 1000 characters), or more than 500 comments
     * Update Code Comments
     */
    async updateCodeCommentsRaw(requestParameters: UpdateCodeCommentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CodeRead>> {
        if (requestParameters['codeId'] == null) {
            throw new runtime.RequiredError(
                'codeId',
                'Required parameter "codeId" was null or undefined when calling updateCodeComments().'
            );
        }

        if (requestParameters['codeCommentsUpdate'] == null) {
            throw new runtime.RequiredError(
                'codeCommentsUpdate',
                'Required parameter "codeCommentsUpdate" was null or undefined when calling updateCodeComments().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xOrganizationID'] != null) {
            headerParameters['X-Organization-ID'] = String(requestParameters['xOrganizationID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/codes/{code_id}/comments`.replace(`{${"code_id"}}`, encodeURIComponent(String(requestParameters['codeId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CodeCommentsUpdateToJSON(requestParameters['codeCommentsUpdate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CodeReadFromJSON(jsonValue));
    }

    /**
     * Replace the teacher comments of a code (line number to text) and nothing else.  Staff of the organization in X-Organization-ID, for codes of its active members. An empty object removes every comment.  Raises:     HTTPException: 401 if not authenticated     HTTPException: 403 if not staff of the organization     HTTPException: 404 if the code is missing or its owner is not an active member     HTTPException: 422 for a key that is not a positive line number, an empty or too long         text (over 1000 characters), or more than 500 comments
     * Update Code Comments
     */
    async updateCodeComments(requestParameters: UpdateCodeCommentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CodeRead> {
        const response = await this.updateCodeCommentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const ListCurrentUserCodesPageOrderEnum = {
    Desc: 'desc',
    Asc: 'asc'
} as const;
export type ListCurrentUserCodesPageOrderEnum = typeof ListCurrentUserCodesPageOrderEnum[keyof typeof ListCurrentUserCodesPageOrderEnum];
